// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c0af7d12","703":"35c27f3b","787":"a026adf0"}[chunkId] + ".chunk.js";
};